export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-thumbnail-480-72088c81fa6b5e546fbdf0bb94762094.png";